import React from "react";
import { List, useGetList, Link, } from "react-admin";
import { makeStyles, Grid, Card, CardContent, Typography, Box } from '@material-ui/core';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import lightTheme from '../layout/themes';

const useStyles = makeStyles({
  PostTitle: lightTheme.PostTitle,
  PostSubTitle: lightTheme.PostSubTitle,
  FolderGrid:{
    marginTop: '20px',
  },
  Folder:{
    '& .MuiCardContent-root':{
      padding: '24px !important'
    },
    '& #FolderTitle':{
      color: '#424242',
      fontSize: '15px',
      '& svg':{
        marginBottom: '-5px',
        marginRight: '15px',
      }
    }
  }
});

const NewsletterListGrid = () => {
  const classes = useStyles();
  const { data, ids } = useGetList('newsletter', { page: 1, perPage: 10 })
  return(
    <Grid container spacing={2} className={classes.FolderGrid}>
      {ids.map(id => (
        <Grid key={id} xs={3} sm={3} md={4} lg={4} xl={4} item >
          <Card className={classes.Folder}>
            <Link to={`/Newsletter/${data[id].id}/edit`}>
              <CardContent>
                <Typography id="FolderTitle">
                  <MailOutlineRoundedIcon />{data[id].title}
                </Typography>
              </CardContent>
            </Link>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}


const NewsletterList = props => {
  const classes = useStyles();
  return (
    <Box>
      <Box display="flex" style={{ width: '100%', position: 'relative', top: '8px'}} justifyContent="flex-start">
        <Typography className={classes.PostTitle}>Newsletter Trendico NET</Typography>
        <Typography className={classes.PostSubTitle}>&nbsp;Gestiona los correos de las Newsletters</Typography>
      </Box>
      <List {...props} actions={false} pagination={false} component="div">
        <NewsletterListGrid />
      </List>
    </Box>
  )
}; export default NewsletterList;